"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteUserPreference = exports.SetUserPreference = exports.GetUserPreference = exports.GetHealth = void 0;
// This file is auto-generated, do not modify directly!
var GetHealth = {
  endpoint: '/healthcheck',
  method: 'get'
};
exports.GetHealth = GetHealth;
var GetUserPreference = {
  endpoint: '/user-preference/{key}',
  method: 'get'
};
exports.GetUserPreference = GetUserPreference;
var SetUserPreference = {
  endpoint: '/user-preference/{key}',
  method: 'post'
};
exports.SetUserPreference = SetUserPreference;
var DeleteUserPreference = {
  endpoint: '/user-preference/{key}',
  method: 'delete'
};
exports.DeleteUserPreference = DeleteUserPreference;